import { Optional, YesNoAnswer } from "../commons.types";
import { FormikPhoneNumber } from "./formik-commons.types";

export enum InjuredType {
  DRIVER_A = "CONDUCENTE_A",
  DRIVER_B = "CONDUCENTE_B",
  PASSENGER_A = "PASSEGGERO_A",
  PASSENGER_B = "PASSEGGERO_B",
  WALKER = "PEDONE",
}

export enum AuthorityType {
  MUNICIPAL_POLICE = "VIGILI_URBANI",
  CARABINIERI = "CARABINIERI",
  STATE_POLICE = "POLIZIA_DI_STATO",
  EMPTY = "EMPTY",
}

export enum VehicleType {
  VEHICLE_A = "VEICOLO_A",
  VEHICLE_B = "VEICOLO_B",
}

export enum AccidentCircumstanceKeyEnum {
  PARKED_OR_STOPPED = "inFermataOSosta",
  MOVING_OFF_AFTER_STOP = "ripartivaDopoSosta",
  PARKING = "stavaParcheggiando",
  LEAVING_PARKING = "uscivaDaParcheggio",
  ENTERING_PARKING = "entravaInParcheggio",
  ENTERING_SQUARE = "siImmettevaInUnaPiazza",
  DRIVING_IN_SQUARE = "circolavaSuUnaPiazza",
  REAR_ENDING_SAME_DIRECTION = "tamponavaStessoSenso",
  MOVING_SAME_DIRECTION = "procedevaStessoSenso",
  CHANGING_LANE = "cambiavaFila",
  OVERTAKING = "sorpassava",
  TURNING_RIGHT = "giravaADestra",
  TURNING_LEFT = "giravaASinistra",
  REVERSING = "retrocedeva",
  INVADING_OPPOSITE_LANE = "invadeSede",
  COMING_FROM_RIGHT = "provieneDestra",
  NO_RIGHT_OF_WAY_OR_RED_LIGHT = "noPrecedenzaOSemaforoRosso",
}

export type FormikInjured = {
  type: Optional<InjuredType>;
  surname: string;
  name: string;
  phoneNumber: FormikPhoneNumber;
  email: string;
  fiscalCode: string;
  address: string;
  placeOfBirth: string;
  dateOfBirth: string;
  emergencyRoom: YesNoAnswer;
  emergencyRoomName: string;
  emergencyRoomMunicipality: string;
};

export type FormikInjuredsInfo = {
  injuredQuestion: Optional<YesNoAnswer>;
  injuredList: FormikInjured[];
};

export type FormikWitness = {
  name: string;
  surname: string;
  address: string;
  fiscalCode: string;
  email: string;
  phoneNumber: FormikPhoneNumber;
  placeOfBirth: string;
  dateOfBirth: string;
};

export type FormikAccidentCircumstances = {
  selectedCircumstance: Optional<AccidentCircumstanceKeyEnum>;
  vehicleType: VehicleType;
};

export type FormikAccidentGeneralInfo = {
  accidentDate: string;
  accidentHour: string;
  accidentLocation: string;
};

export type FormikAccidentMaterialDamages = {
  otherVehiclesDamaged: Optional<YesNoAnswer>;
  otherVehiclesDamageDetails: string;
  otherObjectsDamaged: Optional<YesNoAnswer>;
  otherObjectsDamageDetails: string;
};

export type FormikWitnessesInfo = {
  witnessesList: FormikWitness[];
  authorityIntervention: YesNoAnswer;
  authority?: AuthorityType; //NULLABLE PER RICOPRIRE L'OPZIONE 'EMPTY'
};

export type FormikAccidentData = {
  generalInfo: FormikAccidentGeneralInfo;
  injuredsInfo: FormikInjuredsInfo;
  materialDamages: FormikAccidentMaterialDamages;
  witnessesInfo: FormikWitnessesInfo;
  vehicleAccidentCircumstances: FormikAccidentCircumstances[];
};
